import { normalizePath } from '~/utils/url';

/**
 * Pre-processes a catalog label before normalizePath slugging.
 * Matches Umbraco RequestHandler defaults where they differ from normalizePath alone.
 * @see https://docs.umbraco.com/umbraco-cms/reference/configuration/requesthandlersettings
 */
const preprocessLabelForSlug = (input: string) =>
    input
        .replace(/\//g, '')
        .replace(/\+/g, 'plus')
        .replace(/\*/g, 'star')
        .replace(/[?#%:]/g, '')
        .replace(/\./g, '-');

/**
 * Sanitizes a string for URL slug usage (brand/category segments, search exact-match).
 */
export const sanitizeStringForUrl = (input: string | undefined | null) => {
    if (!input) return '';

    const slug = preprocessLabelForSlug(input);
    return normalizePath(`/${slug}`).split('/').pop() || '';
};
